import * as React from "react";

export interface AbortControllerRegistry {
    push: (controller: AbortController) => void;
    abortAll: () => void;
}

export function useAbortControllers(): AbortControllerRegistry {
    const controllersRef = React.useRef(new Set<AbortController>());

    const registryRef = React.useRef<AbortControllerRegistry>({
        push(controller: AbortController) {
            controllersRef.current.add(controller);
            controller.signal.addEventListener("abort", () => controllersRef.current.delete(controller), {
                once: true,
            });
        },
        abortAll() {
            controllersRef.current.forEach((c) => c.abort());
            controllersRef.current.clear();
        },
    });

    React.useEffect(() => {
        return () => registryRef.current.abortAll();
    }, []);

    return registryRef.current;
}
